import template from './partnerDetailItem.html';
import controller from './partnerDetailItem.controller';

export const partnerDetailItemComponent = {
  name: 'partnerDetailItemComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    model: '<',
    inline: '<',
    showSave: '<',
    showReset: '<',
    onSave: '&',
    onReset: '&'
  }
};
